var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCorneringEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Cornering Events",
    role: "img",
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cornering Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.99704 10.5c0 5.79999-9.99704 14.5-9.99704 14.5s-9.99704-8.70001-9.99704-14.5c-.13471-5.65964 4.33923-10.3587 9.99704-10.5 5.65781.1413 10.13175 4.84036 9.99704 10.5z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.998 3.46497c-3.74108 0-6.7851 3.04492-6.7851 6.78711s3.04402 6.78711 6.7851 6.78711 6.7851-3.04492 6.7851-6.78711-3.04402-6.78711-6.7851-6.78711zm0 1c1.91642 0 3.61306.94061 4.6664 2.38031l-3.81229 2.20233c-.24181-.172-.53542-.27551-.85412-.27551-.32064 0-.61572.10522-.85839.27936l-3.81131-2.20148c1.05315-1.44238 2.75144-2.38501 4.6697-2.38501zm0 5.30713c.26506 0 .48033.21533.48033.47998s-.21527.47998-.48033.47998c-.26457 0-.47984-.21533-.47984-.47998s.21527-.47998.47984-.47998zm-5.78539.47998c0-.91437.21887-1.77655.59803-2.54614l3.76152 2.17267c-.03155.12006-.0537.24371-.0537.37347 0 .63965.4104 1.18079.97969 1.38696v4.37482c-2.9564-.25482-5.28554-2.73962-5.28554-5.76178zm6.28525 5.76178v-4.37476c.56966-.20612.98018-.74725.98018-1.38702 0-.13184-.02288-.25732-.0554-.37909l3.7603-2.1723c.38069.77087.60047 1.63495.60047 2.55139 0 3.02216-2.32878 5.50702-5.28554 5.76178z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorneringEventsPoint);
export default __webpack_public_path__ + "static/media/cornering-events-point.26295e4d833b870acb91c2386d5f0c26.svg";
export { ForwardRef as ReactComponent };